import { api } from "./api";

export const studyPlanner = api.injectEndpoints({
    endpoints: (builder) => ({
        getStudyPlannerEvents: builder.query<any, void>({
            query: () => ({
                url: "/StudyPlanner/GetStudyPlannerEvents",
                method: "GET"
            }),
            providesTags: ["StudyPlanner", "StudyPlannerPostForm"]
        }),
        getStudyPlannerAdditionalItems: builder.query<any, void>({
            query: () => ({
                url: "/StudyPlanner/GetStudyPlannerAdditionalItems",
                method: "GET"
            }),
            providesTags: ["StudyPlannerAdditionalItems"]
        }),
        addStudyPlannerAdditionalItem: builder.mutation<any, { Id: string, PlannerDate: string }>({
            query: (body) => {
                return {
                    url: "/StudyPlanner/AddContentItemToPlanner",
                    body: body,
                    method: "POST"
                }
            },
            async onQueryStarted({ Id, PlannerDate }, { dispatch, queryFulfilled }) {
                try {
                    const data = await queryFulfilled;
                    dispatch(
                        studyPlanner.util.updateQueryData("getStudyPlannerEvents", undefined, (draft) => {
                            draft?.Events?.push(data.data);
                        })
                    )

                } catch (error) {
                    console.log(error);
                }
            }
        }),
        getStudyPlannerEvent: builder.query<any, { eventId: number }>({
            query: (args) => {
                const { eventId } = args;
                return {
                    url: `/StudyPlanner/GetStudyPlannerEvent`,
                    method: "GET",
                    params: { eventId }
                }
            },
            providesTags: (result) =>
                result ? [{ type: 'StudyPlannerUpdateEvent', id: result.StudyPlannerUpdateEvent }]
                    : ['StudyPlannerUpdateEvent'],
        }),
        getStudyPlannerForm: builder.query<any, void>({
            query: () => ({
                url: "/StudyPlanner/GetStudyPlannerForm",
                method: "GET"
            })
        }),
        validateEventNewDate: builder.mutation<any, { eventId: number, newDate: string }>({
            query: (body) => ({
                url: "/StudyPlanner/ValidateEventNewDate",
                method: "POST",
                body: body
            }),
            async onQueryStarted({ eventId, newDate }, { dispatch, queryFulfilled }) {
                const validateResult = dispatch(
                    studyPlanner.util.updateQueryData("getStudyPlannerEvents", undefined, (draft) => {
                        const event = draft?.Events?.find((eve: any) => eve.StudyPlannerEventId === eventId)
                        event.Start = newDate;

                        draft?.Events.forEach((ele: any, index: number) => {
                            if (ele.StudyPlannerEventId === eventId) {
                                draft.Events[index] = event;
                            }
                        })
                    })
                )

                try {
                    const res = await queryFulfilled
                    if (res.data.Status === "Error") {
                        validateResult.undo()
                    }
                } catch (error: any) {
                    validateResult.undo()
                }
            }
        }),
        updateEvent: builder.mutation<any, { eventId: number, newDate: string }>({
            query: (body) => ({
                url: "/StudyPlanner/UpdateEvent",
                method: "POST",
                body: body
            }),
            invalidatesTags: (result, error, { eventId }) => [
                { type: 'StudyPlannerUpdateEvent', id: eventId },
                { type: 'StudyPlannerUpdateEvent' }
            ]
        }),
        deleteEvent: builder.mutation<any, { eventId: number }>({
            query: (body) => ({
                url: "/StudyPlanner/DeleteAdditionalItem",
                method: "POST",
                body: body
            }),
            async onQueryStarted({ eventId }, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(
                        studyPlanner.util.updateQueryData("getStudyPlannerEvents", undefined, (draft) => {
                            const eventIndex = draft?.Events?.findIndex((eve: any) => eve.StudyPlannerEventId === eventId);
                            draft?.Events.splice(eventIndex, 1);
                        })
                    )
                } catch (error: any) {
                    console.log(error)
                }
            },
            invalidatesTags: ["StudyPlannerAdditionalItems"]
        }),
        postStudyPlannerForm: builder.mutation<any, { StartDate: string, ExamDate: string, HoursPerWeek: number }>({
            query: (body) => ({
                url: "/StudyPlanner/PostStudyPlannerForm",
                method: "POST",
                body: body
            }),
            invalidatesTags: ["StudyPlannerPostForm"]
        })
    })
})

export const {
    useGetStudyPlannerEventsQuery,
    useLazyGetStudyPlannerEventsQuery,
    useGetStudyPlannerAdditionalItemsQuery,
    useGetStudyPlannerEventQuery,
    useAddStudyPlannerAdditionalItemMutation,
    useGetStudyPlannerFormQuery,
    useValidateEventNewDateMutation,
    useUpdateEventMutation,
    useDeleteEventMutation,
    usePostStudyPlannerFormMutation,
} = studyPlanner;
